import { useQuery } from '@tanstack/react-query'
import { useEffect, useState } from 'react'

import { QUERY_KEYS } from 'constants/constants'
import { query } from '../graphql'
import { notifyBugsnag } from '../helpers'
import {
  markSpaceWithoutPayment,
  unmarkSpaceWithoutPayment
} from '../helpers/spaces-without-payment'

export const usePaymentsQuery = ({
  partner_id,
  active_space_id,
  cognitoUser
}) => {
  const [accessDenied, setAccessDenied] = useState(false)

  const result = useQuery({
    queryKey: QUERY_KEYS.paymentByPartner(partner_id),
    queryFn: async () => {
      const response = await query({
        query: 'paymentByPartnerIdByCreatedAt',
        variables: { partner_id }
      })

      if (!response.length) {
        setAccessDenied(true)

        const message = `no payment found / access denied - username: ${cognitoUser.username} / partner_id: ${partner_id}`
        notifyBugsnag(new Error(message))
        return []
      }

      return response
    },
    enabled: !!partner_id
  })

  // Marker für den Space-Switch: welcher Space führt in den AccessDenied-Screen.
  // Bewusst außerhalb der queryFn, damit der queryKey (['payment', partner_id])
  // unverändert bleibt und der Cache nicht pro Space aufsplittet.
  //
  // Der Payment-Status *fremder* Spaces ist client-seitig nicht abfragbar
  // (siehe helpers/spaces-without-payment) — der tatsächlich beobachtete Fall
  // für den jeweils aktiven Space ist die einzige verlässliche Quelle.
  useEffect(() => {
    if (!active_space_id) return

    if (accessDenied) {
      markSpaceWithoutPayment(active_space_id)
      return
    }

    if (result.data?.length) unmarkSpaceWithoutPayment(active_space_id)
  }, [accessDenied, active_space_id, result.data])

  return { accessDenied, ...result }
}
